var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.initialized || _vm.isLoginPage || _vm.isNoAccessPage)?[_c('app-navigation-drawer'),_c('v-main',[_c('app-bar'),_c('router-view')],1),_c('app-overlay'),_c('app-fullscreen-dialog')]:[_c('app-loader')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }